var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldShieldSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.45 9.45c0 .71-.72 1.17-1.39.92a6.11 6.11 0 0 0-2.75-.33c-2.38.26-4.82 2.55-5.22 4.92-.33 1.97.3 3.81 1.51 5.11.55.6.18 1.57-.63 1.66-.69.08-1.37.06-1.75-.22l-5.5-4.11c-.65-.49-1.18-1.55-1.18-2.37V6.94c0-1.13.86-2.37 1.91-2.77l5.5-2.06c.57-.21 1.51-.21 2.08 0l5.5 2.06c1.06.4 1.92 1.64 1.92 2.77v2.51z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 16.012c0 2.48 2.02 4.5 4.5 4.5s4.5-2.02 4.5-4.5a4.5 4.5 0 0 0-4.5-4.5c-2.48 0-4.5 2.02-4.5 4.5zM20.29 21.71c-.04-.05-.09-.1-.12-.16a.556.556 0 0 1-.09-.17.636.636 0 0 1-.06-.18c-.01-.07-.02-.13-.02-.2 0-.13.03-.26.08-.38.05-.13.12-.23.21-.33.23-.23.58-.34.9-.27.07.01.13.03.19.06.06.02.12.05.17.09.06.03.11.08.16.12.09.1.16.2.21.33.05.12.08.25.08.38 0 .26-.11.52-.29.71-.05.04-.1.08-.16.12-.05.04-.11.07-.17.09-.06.03-.12.05-.19.06-.06.01-.13.02-.19.02-.27 0-.52-.11-.71-.29z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldShieldSearch);
export default __webpack_public_path__ + "static/media/vuesax-bold-shield-search.aa36739b8197c328f24cff8db9465006.svg";
export { ForwardRef as ReactComponent };